import PropTypes from 'prop-types';

import {
  STYLING_VALUE_BORDER_STYLE_DASHED,
  STYLING_VALUE_BORDER_STYLE_DOTTED,
  STYLING_VALUE_BORDER_STYLE_DOUBLE,
  STYLING_VALUE_BORDER_STYLE_GROOVE,
  STYLING_VALUE_BORDER_STYLE_INSET,
  STYLING_VALUE_BORDER_STYLE_NONE,
  STYLING_VALUE_BORDER_STYLE_OUTSET,
  STYLING_VALUE_BORDER_STYLE_RIDGE,
  STYLING_VALUE_BORDER_STYLE_SOLID,
  STYLING_VALUE_FONT_STYLE_ITALIC,
  STYLING_VALUE_FONT_STYLE_NORMAL,
  STYLING_VALUE_FONT_WEIGHT_BOLD,
  STYLING_VALUE_FONT_WEIGHT_NORMAL,
  STYLING_VALUE_STICK_TO_LEFT,
  STYLING_VALUE_STICK_TO_TOP,
  STYLING_VALUE_TEXT_DECORATION_NONE,
  STYLING_VALUE_TEXT_DECORATION_UNDERLINE,
  STYLING_VALUE_TEXT_TRANSFORM_NONE,
  STYLING_VALUE_TEXT_TRANSFORM_UPPERCASE,
} from 'sharedParts';

export const propTypeBorderStyle = PropTypes.oneOf([
  STYLING_VALUE_BORDER_STYLE_DASHED,
  STYLING_VALUE_BORDER_STYLE_DOTTED,
  STYLING_VALUE_BORDER_STYLE_DOUBLE,
  STYLING_VALUE_BORDER_STYLE_GROOVE,
  STYLING_VALUE_BORDER_STYLE_INSET,
  STYLING_VALUE_BORDER_STYLE_NONE,
  STYLING_VALUE_BORDER_STYLE_OUTSET,
  STYLING_VALUE_BORDER_STYLE_RIDGE,
  STYLING_VALUE_BORDER_STYLE_SOLID,
]);
export const propTypeFontStyle = PropTypes.oneOf([
  STYLING_VALUE_FONT_STYLE_ITALIC,
  STYLING_VALUE_FONT_STYLE_NORMAL,
]);
export const propTypeFontWight = PropTypes.oneOf([
  STYLING_VALUE_FONT_WEIGHT_BOLD,
  STYLING_VALUE_FONT_WEIGHT_NORMAL,
]);
export const propTypeStickTo = PropTypes.oneOf([
  STYLING_VALUE_STICK_TO_LEFT,
  STYLING_VALUE_STICK_TO_TOP,
]);
export const propTypeTextDecoration = PropTypes.oneOf([
  STYLING_VALUE_TEXT_DECORATION_NONE,
  STYLING_VALUE_TEXT_DECORATION_UNDERLINE,
]);
export const propTypeTextTransform = PropTypes.oneOf([
  STYLING_VALUE_TEXT_TRANSFORM_NONE,
  STYLING_VALUE_TEXT_TRANSFORM_UPPERCASE,
]);
